import React from 'react';
import Route from 'react-router/lib/Route';
import store from 'store';
import { setTitle } from 'shared/topBanner/actionTypes';
import MaintenanceContainer from './MaintenanceContainer.jsx';
import Unauthorized from './Unauthorized.jsx';
import { retrieveMaintenanceMessage } from 'shared/auth/actions.js';

const routes = (
  <div>
    <Route
      path="maintenance"
      component={MaintenanceContainer}
      onEnter={() => {
        store.dispatch(retrieveMaintenanceMessage());
      }}
    />
    <Route
      path="signin/unauthorized"
      component={Unauthorized}
      onEnter={() => {
        store.dispatch(setTitle('Unauthorized'));
      }}
    />    
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/features/shared/auth/routes.js